import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { spaceL, spaceXXS, scale230, scale050 } from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

const StyledFooter = styled.div`
  height: ${scale230};
  padding: ${scale050} ${spaceL} ${spaceL};
`;

const StyledFooterHeadline = styled(Headline)`
  ${lineClamp(2)};
  margin-bottom: ${spaceXXS};
`;

const StyledBodyCopy = styled(BodyCopy)`
  ${lineClamp(2)};
`;

export const Styled = {
  Footer: StyledFooter,
  FooterHeadline: StyledFooterHeadline,
  BodyCopy: StyledBodyCopy,
};
